<div class="padding no-x-padding bottom-padding d-flex fd-row ai-stretch">
  <h4 class="header-top-margin" style="opacity: 0.8">
    {{ option.filterMethodConfig.title }}
  </h4>
  <form [formGroup]="formGroup">
    <mat-checkbox
      color="primary"
      formControlName="checkbox"
      [checked]="checked"
      (change)="onToggle($event)"
      color="primary"
      >{{ option.filterMethodConfig.name }}</mat-checkbox
    >
  </form>
</div>
